import React, { useEffect, useState } from 'react';
import { PlansAPI } from '../../../../api/payments/plans/api';
import { AddonsAPI } from '../../../../api/payments/addons/api';
import {
  CouponScopeLabels,
  CouponValueTypeLabels,
} from '../../../../api/payments/coupons/domain/labels';
import { formatCycleRange, formatRuleValue } from '../utils';
import { DiscountPricePreview } from './DiscountPricePreview';
import { JdsTag } from '../../../../components/jds/JdsTag';

const tag = () => <JdsTag label="Ao total" color="success" />;

function getDiscountTargetLabel(discount, plansById, addonsById) {
  const scope = discount.scope;
  if (scope === 'PLAN') {
    if (!discount.planId) return 'Em qualquer plano';
    return plansById[discount.planId]?.name ?? 'Em qualquer plano';
  }
  if (scope === 'ADDON_TOTAL' || scope === 'ADDON_ITEM') {
    if (!discount.addonId) return 'Em qualquer addon';
    return addonsById[discount.addonId] ?? 'Em qualquer addon';
  }
  return tag();
}

export function CouponDiscountsTable({ discounts }) {
  const [plansById, setPlansById] = useState({});
  const [addonsById, setAddonsById] = useState({});

  useEffect(() => {
    const needsPlans = discounts.some((d) => d.scope === 'PLAN');
    const needsAddons = discounts.some(
      (d) => d.scope === 'ADDON_TOTAL' || d.scope === 'ADDON_ITEM',
    );

    if (needsPlans) {
      PlansAPI.list()
        .then((response) => {
          const map = {};
          (response.data.content || []).forEach((plan) => {
            map[plan.id] = plan;
          });
          setPlansById(map);
        })
        .catch(() => setPlansById({}));
    }

    if (needsAddons) {
      AddonsAPI.list()
        .then((response) => {
          const map = {};
          (response.data.content || []).forEach((addon) => {
            map[addon.id] = addon.name;
          });
          setAddonsById(map);
        })
        .catch(() => setAddonsById({}));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [discounts]);

  if (discounts.length === 0) {
    return <span className="text-muted">Nenhum desconto configurado</span>;
  }

  return (
    <div style={{ overflowX: 'auto', width: '100%' }}>
      <table className="table jds-table">
        <thead>
          <tr>
            <th>Aplicado a</th>
            <th>Tipo de desconto</th>
            <th>Valor</th>
            <th>Ciclos</th>
            <th>Produto/Plano</th>
          </tr>
        </thead>
        <tbody>
          {discounts.map((discount, index) => (
            <tr key={discount.id ?? index}>
              <td>{CouponScopeLabels[discount.scope] ?? discount.scope}</td>
              <td>
                {CouponValueTypeLabels[
                  discount.valueType ?? discount.value_type
                ] ??
                  discount.valueType ??
                  discount.value_type}
              </td>
              <td>
                {formatRuleValue(discount)}
                {discount.scope === 'PLAN' && (
                  <DiscountPricePreview
                    plan={plansById[discount.planId]}
                    valueType={discount.valueType ?? discount.value_type}
                    value={discount.value}
                    hideLabel
                  />
                )}
              </td>
              <td>{formatCycleRange(discount.fromCycle, discount.toCycle)}</td>
              <td>{getDiscountTargetLabel(discount, plansById, addonsById)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
